import axios from 'axios';
import config from '../config/config';

const setupAxiosInterceptors = (navigate) => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                // Token expired or invalid
                console.warn("Session expired or unauthorized. Logging out...");

                localStorage.removeItem("userToken");
                localStorage.removeItem("userId");
                localStorage.removeItem("selectedTenant");
                localStorage.removeItem("userEmail");
                localStorage.removeItem("userName");

                // Force redirect to login
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
            return Promise.reject(error);
        }
    );
};

export default setupAxiosInterceptors;
